'use client';

import { MapComponent } from '@/features/country/components/CountryMap/MapComponent';
import { type CountryBubbleData } from '@/features/country/components/CountryMap/types';
import CountryMapDetails from '@/features/country/components/CountryMapDetails/CountryMapDetails';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { useState } from 'react';

interface ProductCountriesMapProps {
  bubbleData: CountryBubbleData[];
  isLoggedIn: boolean;
  productName: string;
}

export const ProductCountriesMap = ({ bubbleData, isLoggedIn, productName }: ProductCountriesMapProps) => {
  // Local state instead of the shared country map store: the store is global, and the details
  // dialog renders a product dialog that contains this map again, so a shared selection would
  // re-open the same dialog inside itself.
  const [selectedCountry, setSelectedCountry] = useState<CountryBubbleData | null>(null);

  if (bubbleData.length === 0) {
    return null;
  }

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <MapComponent
        bubbleData={bubbleData}
        isLoggedIn={isLoggedIn}
        productName={productName}
        onSelectCountry={setSelectedCountry}
      />
      {selectedCountry && (
        <CountryMapDetails
          isVisible
          onClose={() => {
            setSelectedCountry(null);
          }}
          country={selectedCountry}
        />
      )}
    </Box>
  );
};
